<template>
  <header id="page-header">
    <div class="content-header">
      <div>
        <button type="button" class="btn btn-alt-secondary me-1" data-toggle="layout" data-action="sidebar_toggle">
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div>
        <div v-if="store.state.devices.length > 0" class="dropdown d-inline-block me-2">
          <button
            type="button"
            class="btn btn-alt-secondary dropdown-toggle"
            id="dropdown-devices"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i :class="[store.state.deviceActive ? 'fa fa-signal text-success' : 'fa fa-times text-danger', 'mx-1']"></i>
            <span class="device-name d-sm-inline-block">
              {{ store.state.selectedDevice.name }}
            </span>
          </button>

          <div class="dropdown-menu dropdown-menu-end p-0 overflow-hidden" aria-labelledby="dropdown-devices" style="min-width: 280px; max-height: 500px; overflow-y: auto;">
            <div class="bg-primary-dark fw-semibold text-white text-center p-3">
              <i class="fa fa-microchip me-2"></i> Mis Dispositivos
            </div>

            <div class="p-2">
              <div v-for="(devices, companyName) in groupedDevices" :key="companyName" class="mb-1">
                
                <details v-if="companyName !== 'Sin Empresa'" class="company-group" @click.stop>
                  <summary class="btn btn-alt-secondary w-100 text-start d-flex justify-content-between align-items-center py-2 px-3 border-0 mb-1">
                    <span class="fw-bold small text-uppercase">
                      <i class="fa fa-building me-2"></i>{{ companyName }}
                    </span>
                    <i class="fa fa-chevron-down nav-main-link-icon fs-xs opacity-50"></i>
                  </summary>
                  
                  <div class="ps-2">
                    <a
                      v-for="device in devices"
                      :key="device._id"
                      class="dropdown-item d-flex align-items-center rounded-2 py-2 mb-1"
                      style="cursor: pointer"
                      @click="selectDevice(device.originalIndex)"
                    >
                      <i :class="[device.name == store.state.selectedDevice.name ? 'fa fa-dot-circle text-success' : 'fa fa-circle text-muted', 'fs-xs me-2']"></i>
                      <span :class="{'fw-bold': device.name == store.state.selectedDevice.name}">
                        {{ device.name }}
                      </span>
                    </a>
                  </div>
                </details>

                <div v-else>
                  <div class="dropdown-header text-uppercase fw-bold text-muted pb-1" style="font-size: 0.7rem;">
                    Sin Empresa
                  </div>
                  <a
                    v-for="device in devices"
                    :key="device._id"
                    class="dropdown-item d-flex align-items-center rounded-2 py-2 mb-1"
                    style="cursor: pointer"
                    @click="selectDevice(device.originalIndex)"
                  >
                    <i :class="[device.name == store.state.selectedDevice.name ? 'fa fa-dot-circle text-success' : 'fa fa-circle text-muted', 'fs-xs me-2']"></i>
                    <span :class="{'fw-bold': device.name == store.state.selectedDevice.name}">
                      {{ device.name }}
                    </span>
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="dropdown d-inline-block">
          <button type="button" class="btn btn-alt-secondary" data-bs-toggle="dropdown">
            <i class="fa fa-fw fa-user"></i>
            <i class="fa fa-fw fa-angle-down opacity-50 ms-1 d-none d-sm-inline-block"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end p-0 border-0 shadow-sm">
            <div class="bg-primary-dark rounded-top fw-semibold text-white text-center p-3">Opciones</div>
            <div class="p-2">
              <a @click="showAlertConfirm(
                'Salir',
                'Desea Cerrar Esta Sesion ?',
                'user',
                'logout'
              )" class="dropdown-item" style="cursor: pointer">
                <i class="fa fa-sign-out-alt me-1 text-danger"></i> Salir
              </a>
            </div>
          </div>
        </div>

        </div>
    </div>
  </header>
</template>

<script>
import useApp from "@/composables/useApp";
import { onMounted, ref, inject, computed } from "vue";
import { useStore } from "vuex";
import emitter from "@/eventBus";
import useNotifications from "@/composables/useNotifications";

export default {
  name: "Header",
  setup() {
    const store = useStore();
    let selectedDevice = ref(null);
    onMounted(() => {
      store.dispatch("getCompanies")
      store.dispatch("getDevices");
      store.dispatch("getNotifications");
      emitter.on("selectedDeviceIndex", (index) => {
        selectedDevice.value = index;
      });
    });
    const { selectDevice, logOut, unixToDate } = useApp();
    const swal = inject("$swal");
    const { notificationReaded } = useNotifications();
    const showAlertConfirm = (title, text, icon, funct) => {
      swal({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          if (funct == "logout") {
            logOut();
          }
        }
      });
    };
    
      const groupedDevices = computed(() => {
      const groups = {};
      const assignedDeviceIds = new Set();

      // 1. Agrupamos los dispositivos que pertenecen a empresas registradas
      store.state.companies.forEach(company => {
        groups[company.name] = [];
        
        company.devices.forEach(devId => {
          // Buscamos el objeto completo del dispositivo en el store por su ID
          const deviceIndex = store.state.devices.findIndex(d => d._id === devId);
          
          if (deviceIndex !== -1) {
            const device = store.state.devices[deviceIndex];
            groups[company.name].push({ ...device, originalIndex: deviceIndex });
            assignedDeviceIds.add(devId); // Marcamos como asignado
          }
        });
      });

      // 2. Agrupamos los dispositivos "Huérfanos" (Sin Empresa)
      const orphans = [];
      store.state.devices.forEach((device, index) => {
        if (!assignedDeviceIds.has(device._id)) {
          orphans.push({ ...device, originalIndex: index });
        }
      });

      if (orphans.length > 0) {
        groups['Sin Empresa'] = orphans;
      }

      return groups;
    });


    return {
      showAlertConfirm,
      store,
      selectDevice,
      unixToDate,
      notificationReaded,
      groupedDevices
    };
  },
};
</script>
<style>
.notification-badge {
  position: relative;
  top: 0;
  right: 0;
  width: 12px;
  height: 12px;
  background-color: red;
  border-radius: 50%;
  border: 2px solid white; /* Para dar un borde blanco y que se vea mejor */
}
.device-name {
  white-space: nowrap;
}

@media (max-width: 576px) {
  .device-name {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }
}

/* Estilo para quitar la flecha por defecto de summary */
summary::-webkit-details-marker {
  display: none;
}
summary {
  list-style: none;
  outline: none;
}

/* Efecto cuando el grupo está abierto */
details[open] summary i.fa-chevron-down {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.dropdown-item:active, .dropdown-item.active {
  background-color: #f0f3f8;
  color: #334155;
}

.company-group .dropdown-item {
    font-size: 0.85rem;
}
</style>

